import { useEffect, useMemo, useState } from "react";

function storageKey({ sessionCode, stage, playerId }) {
  return `inspected:${sessionCode}:s${stage}:p${playerId}`;
}

function loadInspectedArray(k) {
  try {
    const raw = localStorage.getItem(k);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function useInspectProgress({ sessionCode, stage, playerId, keys = [] }) {
  const [bump, setBump] = useState(0);

  const k = useMemo(() => {
    if (!sessionCode || !Number.isFinite(Number(stage)) || !Number.isFinite(Number(playerId))) {
      return "";
    }
    return storageKey({ sessionCode, stage: Number(stage), playerId: Number(playerId) });
  }, [sessionCode, stage, playerId]);

  useEffect(() => {
    // 🔁 multi-onglets
    const onStorage = (e) => {
      if (!k) return;
      if (e.key === k) setBump((n) => n + 1);
    };

    // même onglet (dispatch depuis useInspections)
    const onChanged = (e) => {
      if (!k) return;
      if (e?.detail?.storageKey === k) setBump((n) => n + 1);
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener("inspections:changed", onChanged);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("inspections:changed", onChanged);
    };
  }, [k]);

  const inspectedCount = useMemo(() => {
    if (!k) return 0;
    const inspected = new Set(loadInspectedArray(k));
    return keys.reduce((acc, id) => acc + (inspected.has(id) ? 1 : 0), 0);
  }, [k, keys, bump]);

  return {
    inspectedCount,
    total: keys.length,
    done: keys.length > 0 && inspectedCount >= keys.length,
  };
}
